import { render } from "./CircledExclamationIcon.vue?vue&type=template&id=ccda309e&scoped=true"
import script from "./CircledExclamationIcon.vue?vue&type=script&lang=js"
export * from "./CircledExclamationIcon.vue?vue&type=script&lang=js"

import "./CircledExclamationIcon.vue?vue&type=style&index=0&id=ccda309e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ccda309e"

export default script